
import Melanio from '../images/Oliva/Melanio.png'
import BG from '../images/Oliva/BG.jpg'

import vChurchil from '../images/Oliva/vChurchill.png'

import O from '../images/Oliva/O.png'

import gChurchill from '../images/Oliva/gChurchil.png'

import GRChurchill from '../images/Oliva/CRChurchill.png'

import MBChurchill from '../images/Oliva/MBChurchill.png'


// The Serie V Melanio

import OlivaChurchill from '../images/Oliva/Melanio/Churchil.png'
import OlivaChurchillOpen from '../images/Oliva/Melanio/OlivaChurchilOpen.jpg'
import OlivaChurchillClosed from '../images/Oliva/Melanio/OlivaChurchilClosed.jpg'

import Toro from '../images/Oliva/Melanio/Toro.png'
import ToroOpen from '../images/Oliva/Melanio/ToroOpen.jpg'
import ToroClosed from '../images/Oliva/Melanio/ToroClosed.jpg'


import Figurado from '../images/Oliva/Melanio/Figurado.png'
import FiguradoOpen from '../images/Oliva/Melanio/FiguradoOpen.jpg'
import FiguradoClosed from '../images/Oliva/Melanio/FiguradoClosed.jpg'

import Torpedo from '../images/Oliva/Melanio/Torpedo.png'
import TorpedoOpen from '../images/Oliva/Melanio/TorpedoOpen.jpg'
import TorpedoClosed from '../images/Oliva/Melanio/TorpedoClosed.jpg'

import MaduroChurchill from '../images/Oliva/Melanio/MaduroChurchill.png'
import MaduroChurchillOpen from '../images/Oliva/Melanio/MaduroChurchillOpen.jpg'
import MaduroChurchillClosed from '../images/Oliva/Melanio/MaduroChurchilClosed.jpg'

import MaduroTorpedo from '../images/Oliva/Melanio/MaduroTorpedo.png'
import MaduroTorpedoOpen from '../images/Oliva/Melanio/MaduroTorpedoOpen.jpg'
import MaduroTorpedoClosed from '../images/Oliva/Melanio/MaduroTorpedoClosed.jpg'



//The seria V

import VChurchil from '../images/Oliva/V/vChurchill.png'
import VChurchilOpen from '../images/Oliva/V/VChurchilOpen.jpg'
import VChurchilClosed from '../images/Oliva/V/VChurchilClosed.jpg'

import Lancero from '../images/Oliva/V/Lancero.png'
import LanceroOpen from '../images/Oliva/V/LanceroOpen.jpg'
import LanceroClosed from '../images/Oliva/V/LanceroClosed.jpg'

import SFigurado from '../images/Oliva/V/Figurado.png'
import SFiguradoOpen from '../images/Oliva/V/FiguradoOpen.jpg'
import SFiguradoClosed from '../images/Oliva/V/FiguradoClosed.jpg'

import DoubleToro from '../images/Oliva/V/DoubleToro.png'
import DoubleToroOpen from '../images/Oliva/V/DoubleToroOpen.jpg'
import DoubleToroClosed from '../images/Oliva/V/DoubleToroClosed.jpg'

import VTorpedo from '../images/Oliva/V/VTorpedo.png'
import VTorpedoOpen from '../images/Oliva/V/VTorpedoOpen.jpg'
import VTorpedoClosed from '../images/Oliva/V/VTorpedoClosed.jpg'


//SERIE O
import OChurchil from '../images/Oliva/O/Ochurchill.png'
import OChurchilOpen from '../images/Oliva/O/OchurchillOpen.jpg'
import OChurchilClosed from '../images/Oliva/O/OchurchillClosed.jpg'

import ODToro from '../images/Oliva/O/ODToro.png'
import ODToroOpen from '../images/Oliva/O/ODToroOpen.jpg'
import ODToroClosed from '../images/Oliva/O/ODToroClosed.jpg'

import OTorpedo from '../images/Oliva/O/OTorpedo.png'
import OTorpedoOpen from '../images/Oliva/O/OTorpedoOpen.jpg'
import OTorpedoClosed from '../images/Oliva/O/OTorpedoClosed.jpg'

import OmaduroChurchill from '../images/Oliva/O/OmaduroChurchill.png'
import OmaduroChurchillOpen from '../images/Oliva/O/OmaduroChurchillOpen.jpg'
import OmaduroChurchillClosed from '../images/Oliva/O/OmaduroChurchillClosed.jpg'

import OmaduroDoubleToro from '../images/Oliva/O/OmaduroDoubleToro.png'
import OmaduroDoubleToroOpen from '../images/Oliva/O/OmaduroDoubleToroOpen.jpg'
import OmaduroDoubleToroClosed from '../images/Oliva/O/OmaduroDoubleToroClosed.jpg'

import OmaduroTorpedo from '../images/Oliva/O/OmaduroTorpedo.png'
import OmaduroTorpedoOpen from '../images/Oliva/O/OmaduroTorpedoOpen.jpg'
import OmaduroTorpedoClosed from '../images/Oliva/O/OmaduroTorpedoClosed.jpg'


// Seria G
import GChurchill from '../images/Oliva/G/GChurchill.png'
import GChurchillOpen from '../images/Oliva/G/GChurchillOpen.jpg'
import GChurchillClosed from '../images/Oliva/G/GChurchillClosed.jpg'

import GFigurado from '../images/Oliva/G/GFigurado.png'
import GFiguradoOpen from '../images/Oliva/G/GFiguradoOpen.jpg'
import GFiguradoClosed from '../images/Oliva/G/GFiguradoCLosed.jpg'

import GTorpedo from '../images/Oliva/G/GTorpedo.png'
import GTorpedoOpen from '../images/Oliva/G/GTorpedoOpen.jpg'
import GTorpedoClosed from '../images/Oliva/G/GTorpedoClosed.jpg'

import GMaduroPresidente from '../images/Oliva/G/GMaduroPresidente.png'
import GMaduroPresidenteOpen from '../images/Oliva/G/GMaduroPresidenteOpen.jpg'
import GMaduroPresidenteClosed from '../images/Oliva/G/GMaduroPresidenteClosed.jpg'

import GMaduroChurchill from '../images/Oliva/G/GMaduroChurchill.png'
import GMaduroChurchillOpen from '../images/Oliva/G/GMaduroChurchillOpen.jpg'
import GMaduroChurchillClosed from '../images/Oliva/G/GMaduroChurchillClosed.jpg'

import GMaduroTorpedo from '../images/Oliva/G/GMaduroTorpedo.png'
import GMaduroTorpedoOpen from '../images/Oliva/G/GMaduroTorpedoOpen.jpg'
import GMaduroTorpedoClosed from '../images/Oliva/G/GMaduroTorpedoCLosed.jpg'


//Connecticut Reserve

import CRChurchill from '../images/Oliva/CR/CRChurchill.png'
import CRChurchillOpen from '../images/Oliva/CR/CRChurchillOpen.jpg'
import CRChurchillClosed from '../images/Oliva/CR/CRChurchillClosed.jpg'

import CRTorpedo from '../images/Oliva/CR/CRTorpedo.png'
import CRTorpedoOpen from '../images/Oliva/CR/CRTorpedoOpen.jpg'
import CRTorpedoClosed from '../images/Oliva/CR/CRTorpedoClosed.jpg'

import CRLonsdale from '../images/Oliva/CR/CRLonsdale.png'
import CRLonsdaleOpen from '../images/Oliva/CR/CRLonsdaleOpen.jpg'
import CRLonsdaleClosed from '../images/Oliva/CR/CRLonsdaleClosed.jpg'

import CRDoubleToro from '../images/Oliva/CR/CRDoubleToro.png'
import CRDoubleToroOpen from '../images/Oliva/CR/CRDoubleToroOpen.jpg'
import CRDoubleToroClosed from '../images/Oliva/CR/CRDoubleToroClosed.jpg'

import CRToro from '../images/Oliva/CR/CRToro.png'
import CRToroOpen from '../images/Oliva/CR/CRToroOpen.jpg'
import CRToroClosed from '../images/Oliva/CR/CRToroClosed.jpg'

import CRRobusto from '../images/Oliva/CR/CRRobusto.png'
import CRRobustoOpen from '../images/Oliva/CR/CRRobustoOpen.jpg'
import CRRobustoClosed from '../images/Oliva/CR/CRRobustoClosed.jpg'


//Master blend 3

import MBChurchillCigar from '../images/Oliva/MB/MBChurchill.png'
import MBChurchillOpen from '../images/Oliva/MB/MBChurchillOpen.jpg'
import MBChurchillClosed from '../images/Oliva/MB/MBChurchillClosed.jpg'

import MBTorpedo from '../images/Oliva/MB/MBTorpedo.png'
import MBTorpedoOpen from '../images/Oliva/MB/MBTorpedoOpen.jpg'
import MBTorpedoClosed from '../images/Oliva/MB/MBTorpedoClosed.jpg'

import MBRobosto from '../images/Oliva/MB/MBRobosto.png'
import MBRobostoOpen from '../images/Oliva/MB/MBRobostoOpen.jpg'
import MBRobostoClosed from '../images/Oliva/MB/MBTorpedoClosed.jpg'

export const OliviaData = [
    {
        id: 1,
        title: 'Oliva Serie V Melanio',
        subTitle: 'Oliva Serie V Melanio се валцува ръчно с помощта на експертно ферментирали пълнители ligaro, листа, известни със своя здрав и богат вкус. Пет години в процес на създаване, тази специална пура със сигурност ще надмине най-високите очаквания на пушача на първокласни пури.',
        paragraphOne: `ЗСерия V Меланио Мадуро, направена от смес от никарагуански Хабано, отглеждана в региона Халапа на страната и увита в мексиканско мадуро от буйната долина Сан Андрес. Тази уникална пура със сигурност ще задоволи и най-високите очаквания на пушачите на пура мадуро.`,
        imgUrl: Melanio,
        imagBg: BG,

        cigars: [
            {
                id: 1,
                title: 'Churchill',
                subtitle: '7 x 50',
                img: OlivaChurchill,
                openBox: OlivaChurchillOpen,
                closedBox: OlivaChurchillClosed,
            },
            {
                id: 2,
                title: 'Double Toro',
                subtitle: '6 x 60',
                img: Toro,
                openBox: ToroOpen,
                closedBox: ToroClosed,
            },
            {
                id: 3,
                title: 'Figurado',
                subtitle: '6.5 x 52',
                img: Figurado,
                openBox: FiguradoOpen,
                closedBox: FiguradoClosed,
            },
            {
                id: 4,
                title: 'Torpedo',
                subtitle: '6.5 x 52',
                img: Torpedo,
                openBox: TorpedoOpen,
                closedBox: TorpedoClosed,
            },
            {
                id: 5,
                title: 'Maduro Churchill',
                subtitle: '7 x 50',
                img: MaduroChurchill,
                openBox: MaduroChurchillOpen,
                closedBox: MaduroChurchillClosed,
            },
            {
                id: 6,
                title: 'Maduro Torpedo',
                subtitle: '6.5 x 52',
                img: MaduroTorpedo,
                openBox: MaduroTorpedoOpen,
                closedBox: MaduroTorpedoClosed,
            },


        ]
    },
    {
        id: 2,
        title: 'The V Seria',
        subTitle: 'Serie V е сложна смес от никарагуански тютюни с дълъг пълнител. Смесен със специално ферментирала лига Jalapa Valley и завършен с високо грундиран Habano Sun Grown Wrapper. Тази ароматна смес показва сложен тютюн с богати кафе и тъмни шоколадови тонове. Една фина и добре балансирана подправка присъства навсякъде.',

        imgUrl: vChurchil,
        imagBg: BG,
        cigars: [
            {
                id: 1,
                title: 'Churchill Extra',
                subtitle: '7 x 52',
                img: VChurchil,
                openBox: VChurchilOpen,
                closedBox: VChurchilClosed,
            },
            {
                id: 2,
                title: 'Lancero',
                subtitle: '7 x 38',
                img: Lancero,
                openBox: LanceroOpen,
                closedBox: LanceroClosed,
            },
            {
                id: 3,
                title: 'Special V Figurado',
                subtitle: '6 x 60',
                img: SFigurado,
                openBox: SFiguradoOpen,
                closedBox: SFiguradoClosed,
            },
            {
                id: 4,
                title: 'Double Toro',
                subtitle: '6 x 60',
                img: DoubleToro,
                openBox: DoubleToroOpen,
                closedBox: DoubleToroClosed,
            },
            {
                id: 5,
                title: 'Torpedo',
                subtitle: '6 x 56',
                img: VTorpedo,
                openBox: VTorpedoOpen,
                closedBox: VTorpedoClosed,
            }
        ]

    },
    {
        id: 3,
        title: 'Seria O',
        subTitle: 'Серията O е Habano Puro. Произведено по оригиналната кубинска традиция за отглеждане на едно и също семе на Habano в различни региони на страната, за да се получи различна смес. Тази комбинация е постигната чрез отглеждане на Хабано в Естели, Кондега и долината Джалапа.',

        imgUrl: O,
        imagBg: BG,
        cigars: [
            {
                id: 1,
                title: 'Churchill',
                subtitle: '7 x 50',
                img: OChurchil,
                openBox: OChurchilOpen,
                closedBox: OChurchilClosed
            },
            {
                id: 2,
                title: 'Double Toro',
                subtitle: '6 x 60',
                img: ODToro,
                openBox: ODToroOpen,
                closedBox: ODToroClosed,
            },
            {
                id: 3,
                title: 'Torpedo',
                subtitle: '6.5 x 52',
                img: OTorpedo,
                openBox: OTorpedoOpen,
                closedBox: OTorpedoClosed,
            },
            {
                id: 4,
                title: 'Maduro Churchill',
                subtitle: '7 x 50',
                img: OmaduroChurchill,
                openBox: OmaduroChurchillOpen,
                closedBox: OmaduroChurchillClosed,
            },
            {
                id: 5,
                title: 'Maduro Double Toro',
                subtitle: '6 x 60',
                img: OmaduroDoubleToro,
                openBox: OmaduroDoubleToroOpen,
                closedBox: OmaduroDoubleToroClosed,
            },
            {
                id: 6,
                title: 'Maduro TorpedoClosed',
                subtitle: '6.5 x 52',
                img: OmaduroTorpedo,
                openBox: OmaduroTorpedoOpen,
                closedBox: OmaduroTorpedoClosed,
            },

        ]
    },
    {
        id: 4,
        title: 'The Serie G',
        subTitle: 'Serie G е смес от средно тяло, направена с автентична африканско-камерунска обвивка. Уникалните вкусови нотки на тази обвивка се допълват от естественото богатство на никарагуанските пълнители Habano. Serie G е пура с нотки на кедър и кафе, което я прави отличен баланс на дим',
        imgUrl: gChurchill,
        imagBg: BG,
        cigars: [
            {
                id: 1,
                title: 'Churchill',
                subtitle: '7 x 50',
                img: GChurchill,
                openBox: GChurchillOpen,
                closedBox: GChurchillClosed,
            },
            {
                id: 2,
                title: 'Figurado',
                subtitle: '6.5 x 60',
                img: GFigurado,
                openBox: GFiguradoOpen,
                closedBox: GFiguradoClosed,
            },
            {
                id: 3,
                title: 'Torpedo',
                subtitle: '6.5 x 52',
                img: GTorpedo,
                openBox: GTorpedoOpen,
                closedBox: GTorpedoClosed,
            },
            {
                id: 4,
                title: 'Maduro Presidente',
                subtitle: '8 x 52',
                img: GMaduroPresidente,
                openBox: GMaduroPresidenteOpen,
                closedBox: GMaduroPresidenteClosed,
            },
            {
                id: 5,
                title: 'Maduro Churchill',
                subtitle: '7 x 50',
                img: GMaduroChurchill,
                openBox: GMaduroChurchillOpen,
                closedBox: GMaduroChurchillClosed,
            },
            {
                id: 6,
                title: 'Maduro Torpedo',
                subtitle: '6 x 50',
                img: GMaduroTorpedo,
                openBox: GMaduroTorpedoOpen,
                closedBox: GMaduroTorpedoClosed,
            }
        ]
    },
    {
        id: 5,
        title: 'Connecticut Reserve',
        subTitle: 'Резерват Кънектикът е смесен от никарагуански дълги пълнители и свързващо вещество. Завършена само с най-добрата обвивка от еквадорски Кънектикът, тази пура със средно тяло показва богати вкусове като гладък, копринен дим. Тази мека пура не се отличава с вкус със своите фини нотки на дърво, което я прави идеалната пура "по всяко време".',

        imgUrl: GRChurchill,
        imagBg: BG,
        cigars: [
            {
                id: 1,
                title: 'Churchill',
                subtitle: '7 x 50',
                img: CRChurchill,
                openBox: CRChurchillOpen,
                closedBox: CRChurchillClosed,
            },
            {
                id: 2,
                title: `Torpedo`,
                subtitle: '6.5 x 52',
                img: CRTorpedo,
                openBox: CRTorpedoOpen,
                closedBox: CRTorpedoClosed,
            },
            {
                id: 3,
                title: 'Lonsdale',
                subtitle: '6.5 x 44',
                img: CRLonsdale,
                openBox: CRLonsdaleOpen,
                closedBox: CRLonsdaleClosed,
            },
            {
                id: 4,
                title: 'Double Toro',
                subtitle: '48 (19mm)',
                img: CRDoubleToro,
                openBox: CRDoubleToroOpen,
                closedBox: CRDoubleToroClosed,
            },
            {
                id: 5,
                title: 'Toro',
                subtitle: '6 x 50',
                img: CRToro,
                openBox: CRToroOpen,
                closedBox: CRToroClosed,
            },
            {
                id: 6,
                title: 'Robosto',
                subtitle: '5 x 50',
                img: CRRobusto,
                openBox: CRRobustoOpen,
                closedBox: CRRobustoClosed,
            }


        ]
    },
    {
        id: 6,
        title: 'Master Blends 3',
        subTitle: 'Master Blends 3 е третото предложение от поредица ограничени занаятчийски смеси. Liga Maestra е специално смесена, за да предостави най-богатите характеристики на никарагуанските пълнители на лигаро и обвивките от Broadleaf, отглеждани на слънце. Това е сложна пура, изработена за най-развитото небце.',
        imgUrl: MBChurchill,
        imagBg: BG,
        cigars: [
            {
                id: 1,
                title: `Churchill`,
                subtitle: ' 7 x 50',
                img: MBChurchillCigar,
                openBox: MBChurchillOpen,
                closedBox: MBChurchillClosed,
            },
            {
                id: 2,
                title: `Torpedo`,
                subtitle: '6 x 52',
                img: MBTorpedo,
                openBox: MBTorpedoOpen,
                closedBox: MBTorpedoClosed,
            },
            {
                id: 3,
                title: `Robosto`,
                subtitle: '49 (19mm)',
                img: MBRobosto,
                openBox: MBRobostoOpen,
                closedBox: MBRobostoClosed,
            },

        ]
    }
]